import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionDivider } from '../components/Layout';

export default function IndexPage() {
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState('🏆 2025年7月 JA伊万里きゅうり収穫高第1位受賞！');
  const [instagramPosts, setInstagramPosts] = useState([]);
  const [achievements, setAchievements] = useState([]);

  // microCMSからお知らせを取得
  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await fetch(
          `https://${process.env.REACT_APP_MICROCMS_SERVICE_DOMAIN}.microcms.io/api/v1/news?filters=display_location[contains]お知らせバー&limit=1&orders=-date`,
          {
            headers: {
              'X-MICROCMS-API-KEY': process.env.REACT_APP_MICROCMS_API_KEY,
            },
          }
        );
        const data = await response.json();
        
        if (data.contents && data.contents.length > 0) {
          const item = data.contents[0];
          const date = new Date(item.date);
          const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月`;
          const categoryIcon = {
            'お知らせ': '📢',
            '受賞': '🏆', 
            'プレスリリース': '📺',
            'イベント': '📅'
          };
          const icon = categoryIcon[item.category] || '📢';
          const newAnnouncement = `${icon} ${formattedDate} ${item.title}`;
          setAnnouncement(newAnnouncement);
        }
      } catch (error) {
        console.log('Announcement could not be loaded');
      }
    };

    fetchAnnouncement();
  }, []);

  // microCMSからInstagramデータを取得
  useEffect(() => {
    const fetchInstagramData = async () => {
      try {
        const response = await fetch(
          `https://${process.env.REACT_APP_MICROCMS_SERVICE_DOMAIN}.microcms.io/api/v1/instagram_posts?limit=6&orders=-createdAt`,
          {
            headers: {
              'X-MICROCMS-API-KEY': process.env.REACT_APP_MICROCMS_API_KEY,
            },
          }
        );
        const data = await response.json();

        if (data.contents) {
          setInstagramPosts(data.contents);
        }
      } catch (error) {
        console.log('Instagram data could not be loaded');
      }
    };

    fetchInstagramData();
  }, []);

  // microCMSから受賞歴データを取得
  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const response = await fetch(
          `https://${process.env.REACT_APP_MICROCMS_SERVICE_DOMAIN}.microcms.io/api/v1/news?filters=display_location[contains]農園についてページ&limit=2&orders=-date`,
          {
            headers: {
              'X-MICROCMS-API-KEY': process.env.REACT_APP_MICROCMS_API_KEY,
            },
          }
        );
        const data = await response.json();

        if (data.contents) {
          setAchievements(data.contents);
        }
      } catch (error) {
        console.log('実績データを取得できませんでした');
      }
    };

    fetchAchievements();
  }, []);

  // タイトルの内容によって背景画像を決定
  const getBackgroundImage = (title) => {
    if (title.includes('1位') || title.includes('第1位') || title.includes('１位') || title.includes('第１位')) {
      return '/images/about/jusho1.jpg';
    } else if (title.includes('2位') || title.includes('第2位') || title.includes('２位') || title.includes('第２位')) {
      return '/images/about/jusho2.jpg';
    } else if (title.includes('3位') || title.includes('第3位') || title.includes('３位') || title.includes('第３位')) {
      return '/images/about/jusho3.jpg';
    } else {
      return '/images/about/jusho4.jpg';
    }
  };

  return (
    <div className="min-h-screen relative">
      
      {/* PC版：右上紹介文（768px以上でのみ表示） */}
      <div className="hidden md:block absolute top-0 right-0 py-2 px-4 z-30">
        <span className="text-xs text-white">
          佐賀県伊万里市で科学的農業を実践する若手農家グループ
        </span>
      </div>

      {/* PC版：上部お知らせバー（768px以上でのみ表示） */}
      <div className="hidden md:block absolute top-8 left-40 right-0 bg-gradient-to-r from-red-500 to-red-600 text-white py-1 px-4 z-20 rounded-lg">
        <div className="text-center text-xs font-medium">
          {announcement}
        </div>
      </div>

      {/* スマホ版：ページ上部の紹介文＋お知らせ（768px以下でのみ表示） */}
      <div className="md:hidden bg-white border-b border-stone-200">
        <div className="px-4 py-2 text-center">
          <p className="text-xs" style={{color: '#8b4513'}}>
            佐賀県伊万里市で科学的農業を実践する若手農家グループ
          </p>
        </div>
        <div className="bg-gradient-to-r from-red-500 to-red-600 text-white py-2 px-4">
          <div className="text-center text-xs font-medium">
            {announcement}
          </div>
        </div>
      </div>
      
      {/* ヒーローセクション */}
      <section 
        className="h-80 md:h-screen flex items-start justify-start md:items-end md:justify-end relative pt-8 md:pt-28 pb-12 pr-12 pl-4 md:pl-0"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/hero/hero_mobile.jpg")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* PC版背景画像 */}
        <div 
          className="hidden md:block absolute inset-0 z-0"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/hero/hero_desktop.jpg")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        <div className="text-left md:text-right relative z-10">
          <h2 className="font-bold text-white leading-tight" style={{
            fontSize: window.innerWidth >= 768 ? '56px' : '24px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
          }}>
            農作物にも<br />
            人にも<br />
            <span className="text-orange-300">優しい農園</span>
          </h2>
        </div>
      </section>

      {/* SVG区切り1: ヒーロー → About */}
      <SectionDivider title="about" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 立石農園について */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="px-4 md:px-0">
                <div className="max-w-2xl mx-auto bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-50 rounded-2xl p-8 md:p-10 shadow-sm border" style={{borderColor: '#e5d3b3'}}>
                  <p className="text-base md:text-xl leading-loose md:leading-loose text-center" style={{color: '#8b4513', fontWeight: '500', letterSpacing: '0.02em'}}>
                    立石農園では、<span style={{color: '#ff8c00'}}>３</span>つの<span style={{color: '#ff8c00'}}>理念</span>と<span style={{color: '#ff8c00'}}>３</span>つの<span style={{color: '#ff8c00'}}>想い</span>を基軸として、<br className="hidden md:block" />
                    <span style={{color: '#ff8c00'}}>科学</span>的農業と<span style={{color: '#ff8c00'}}>地域</span>の恵みを融合させ、<br className="hidden md:block" />
                    <span style={{color: '#ff8c00'}}>人</span>にも<span style={{color: '#ff8c00'}}>農作物</span>にも<span style={{color: '#ff8c00'}}>優しい</span>農業を実践しています。
                  </p>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り: About → 3つの理念 */}
      <SectionDivider title="philosophy" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 3つの理念 */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="space-y-6 mb-8">

                {/* 理念1：科学的農業の追求 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img
                      src="/images/about/rinen1.svg"
                      alt="科学的農業の追求"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>オランダ式ハウス×データ管理で最適な環境を実現</h3>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    データと技術で、確かな品質を。科学的データ管理と最新技術を駆使して、安定した高品質な農産物の供給を実現しています。
                  </p>
                </div>

                {/* 理念2：地域価値の創造 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img
                      src="/images/about/rinen2.svg"
                      alt="地域価値の創造"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>20代中心チームで失敗も成功もみんなで共有し成長</h3>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    仲間と共に、未来を育てる。地域に根ざした新しい価値を創造し、持続可能で環境に優しい農業を展開しています。
                  </p>
                </div>

                {/* 理念3：チーム成長 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img
                      src="/images/about/rinen3.svg"
                      alt="チーム成長"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>中山間地域で自作堆肥による持続可能農業を実践</h3>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    地域の恵みを活かし、循環する農業を。20代中心のチームで協力し、地域農業の未来を担う次世代のリーダーを目指しています。
                  </p>
                </div>

              </div>

              {/* 詳しくはこちらボタン */}
              <div className="text-center">
                <button
                  onClick={() => navigate('/about')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#8b4513',
                    border: '2px solid #8b4513',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  詳しくはこちら
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り: 3つの理念 → 3つのメッセージ */}
      <SectionDivider title="messages" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 3つのメッセージ */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="space-y-6 mb-8">

                {/* お客様へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <h3 className="text-base md:text-lg font-bold mb-1 md:mb-2" style={{color: '#8b4513'}}>お客様へ</h3>
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img
                      src="/images/about/messages1.svg"
                      alt="お客様向けメッセージ"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    毎日の食卓に、安心と笑顔をお届けします。安全で美味しい農作物を通じて、ご家族の健康と幸せをサポートいたします。
                  </p>
                </div>

                {/* 事業所様へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>事業所様へ</h3>
                  <div className="w-full h-20 md:h-40 mb-0 rounded-lg">
                    <img
                      src="/images/about/messages2.svg"
                      alt="事業所様向けメッセージ"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    安定した品質と持続可能な供給で、信頼関係を築きます。科学的農業と効率的な生産体制で、お取引先のニーズにお応えします。
                  </p>
                </div>

                {/* 地域の方々へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>地域の方々へ</h3>
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img
                      src="/images/about/messages3.svg"
                      alt="地域の方々向けメッセージ"
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    地域とともに、未来を育てます。地域の自然や文化を大切にしながら、次世代に誇れる農業を築いてまいります。
                  </p>
                </div>

              </div>

              {/* 詳しくはこちらボタン */}
              <div className="text-center">
                <button
                  onClick={() => navigate('/about')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#8b4513',
                    border: '2px solid #8b4513',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  詳しくはこちら
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り: 3つのメッセージ → Products */}
      <SectionDivider title="products" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 農作物 */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">

              <div className="space-y-8">
                {/* きゅうり + オランダ式高軒高ハウス（1つのカード、内部ジグザグ） */}
                <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" style={{border: '1px solid #e5d3b3'}}>
                  <div className="space-y-6">
                    {/* きゅうり：写真左、説明右 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="rounded-xl overflow-hidden shadow-md" style={{height: '250px'}}>
                        <img
                          src="/images/about/crops1.jpg"
                          alt="きゅうり"
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                      <div className="flex flex-col justify-center text-center">
                        <h4 className="heading-3 mb-4" style={{color: '#ff8c00'}}>
                          きゅうり
                        </h4>
                        <ul className="space-y-2 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                          <li>• 年間150トン生産、栽培面積43a</li>
                          <li>• オランダ式高軒高ハウス + 溶液栽培</li>
                          <li>• 科学的データ管理により1年中収穫可能</li>
                        </ul>
                      </div>
                    </div>

                    {/* オランダ式：説明左、写真右 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="flex flex-col justify-center text-center order-2 md:order-1">
                        <h4 className="heading-3 mb-4" style={{color: '#ff8c00'}}>オランダ式高軒高ハウス</h4>
                        <p className="body-text leading-relaxed mb-3" style={{color: '#8b4513', opacity: 0.8}}>
                          施設園芸先進国オランダで開発された次世代型温室システム。天井高が5メートル以上と高く、自動管理することで、1年中高品質なきゅうりを生産しています。
                        </p>
                        <ul className="space-y-2 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                          <li>• 高い天井構造で環境管理がしやすい</li>
                          <li>• 最新の環境制御システム導入</li>
                          <li>• 年間150トンの高い生産性</li>
                        </ul>
                      </div>
                      <div className="rounded-xl overflow-hidden shadow-md order-1 md:order-2" style={{height: '250px'}}>
                        <img
                          src="/images/products/greenhouse_exterior.jpg"
                          alt="オランダ式高軒高ハウス外観"
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* さつまいも + 自作たい肥（1つのカード、内部ジグザグ） */}
                <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" style={{border: '1px solid #e5d3b3'}}>
                  <div className="space-y-6">
                    {/* さつまいも：写真左、説明右 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="rounded-xl overflow-hidden shadow-md" style={{height: '250px'}}>
                        <img
                          src="/images/about/crops2.jpg"
                          alt="さつまいも"
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                      <div className="flex flex-col justify-center text-center">
                        <h4 className="heading-3 mb-4" style={{color: '#ff8c00'}}>
                          さつまいも（紅はるか）
                        </h4>
                        <ul className="space-y-2 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                          <li>• 年間10トン生産、栽培面積50a</li>
                          <li>• 露地栽培、自作堆肥で土作り</li>
                          <li>• 循環型農業で持続可能な栽培を実践</li>
                        </ul>
                      </div>
                    </div>

                    {/* 自作たい肥：説明左、写真右 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="flex flex-col justify-center text-center order-2 md:order-1">
                        <h4 className="heading-3 mb-4" style={{color: '#ff8c00'}}>自作たい肥</h4>
                        <p className="body-text leading-relaxed mb-3" style={{color: '#8b4513', opacity: 0.8}}>
                          木材チップと鶏糞を組み合わせた自作たい肥で伊万里の山と同等の土づくりを目指しています。化学肥料に頼らず、有機質を豊富に含んだたい肥により、持続可能な農業を実践し、健康的で美味しいさつまいもを育てています。
                        </p>
                        <ul className="space-y-2 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                          <li>• 土壌の保水性と通気性を改善</li>
                          <li>• 地域資源を活用した循環型農業</li>
                          <li>• 自然な甘みと風味が豊かに</li>
                        </ul>
                      </div>
                      <div className="rounded-xl overflow-hidden shadow-md order-1 md:order-2" style={{height: '250px'}}>
                        <img
                          src="/images/products/sweetpotato_field.jpg"
                          alt="自作たい肥を使用したさつまいも畑"
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => navigate('/products')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#8b4513',
                    border: '2px solid #8b4513',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  詳しくはこちら
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り3: Products → News */}
      <SectionDivider title="news" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 主な受賞歴 */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  主な受賞歴
                </h2>
                <p className="heading-3" style={{color: '#8b4513', opacity: 0.8}}>
                  科学的農業の成果が認められ、数々の受賞をいただいています
                </p>
              </div>

              {achievements.length > 0 ? (
                <div className="flex flex-wrap justify-center gap-6 mb-8">
                  {achievements.map((achievement, index) => {
                    const date = new Date(achievement.date);
                    const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月`;

                    // 背景画像を決定
                    const backgroundImage = getBackgroundImage(achievement.title);

                    return (
                      <div
                        key={achievement.id}
                        className="relative text-center"
                        style={{
                          width: '400px',
                          height: '200px',
                          borderRadius: '12px',
                          backgroundImage: `url(${backgroundImage})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat'
                        }}
                      >
                        <div className="p-4 flex flex-col justify-center h-full text-center">
                          <p className="caption-text mb-2" style={{color: '#8b4513'}}>{formattedDate}</p>
                          <h4 className="heading-3" style={{color: '#8b4513'}}>{achievement.title}</h4>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex justify-center mb-8">
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: '400px',
                      height: '200px',
                      borderRadius: '12px',
                      backgroundColor: '#f3f4f6',
                      border: '2px dashed #d1d5db'
                    }}
                  >
                    <div className="text-center">
                      <p className="heading-3 mb-2" style={{color: '#8b4513'}}>実績データを読み込めませんでした</p>
                      <p className="caption-text" style={{color: '#8b4513', opacity: 0.6}}>しばらくしてから再度お試しください</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="text-center">
                <button
                  onClick={() => navigate('/news')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#8b4513',
                    border: '2px solid #8b4513',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  お知らせや受賞歴などを見る
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り4: News → SNS */}
      <SectionDivider title="latest" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* Instagram投稿セクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  Instagram
                </h2>
                <p className="heading-3" style={{color: '#8b4513', opacity: 0.8}}>
                  日々の農園の様子をお伝えします
                </p>
              </div>

              {instagramPosts.length === 0 ? (
                // データなし表示
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">📸</span>
                  </div>
                  <p className="heading-3 mb-2" style={{color: '#8b4513'}}>
                    Instagram投稿がありません
                  </p>
                  <p className="body-text" style={{color: '#8b4513', opacity: 0.6}}>
                    しばらくしてから再度ご確認ください
                  </p>
                </div>
              ) : (
                <div>
                  {/* PC版：3列グリッドレイアウト */}
                  <div className="hidden md:grid md:grid-cols-3 gap-6">
                    {instagramPosts.map((post, index) => (
                      <a
                        key={post.id}
                        href="https://www.instagram.com/08._.tate/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white rounded-xl shadow-md overflow-hidden border border-stone-100 hover:shadow-lg transition-shadow block"
                      >
                        <div className="aspect-square overflow-hidden">
                          <img
                            src={post.images?.[0]?.url || '/images/placeholder-instagram.jpg'}
                            alt={`Instagram投稿${index + 1}`}
                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                      </a>
                    ))}
                  </div>

                  {/* スマホ版：横スクロール */}
                  <div className="md:hidden overflow-x-auto">
                    <div className="flex space-x-4 pb-4" style={{width: 'max-content'}}>
                      {instagramPosts.map((post, index) => (
                        <a
                          key={post.id}
                          href="https://www.instagram.com/08._.tate/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-white rounded-xl shadow-md overflow-hidden border border-stone-100 flex-shrink-0 block"
                          style={{width: '280px'}}
                        >
                          <div className="aspect-square overflow-hidden">
                            <img
                              src={post.images?.[0]?.url || '/images/placeholder-instagram.jpg'}
                              alt={`Instagram投稿${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>

                  {/* Instagramへのリンク */}
                  <div className="text-center mt-8">
                    <a
                      href="https://www.instagram.com/08._.tate/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block text-white px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300 hover:opacity-90"
                      style={{background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)'}}
                    >
                      Instagramをもっと見る →
                    </a>
                  </div>
                </div>
              )}
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り5: SNS → Contact */}
      <SectionDivider title="contact" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* お問い合わせ */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="px-4 md:px-0 mb-8">
                <div className="max-w-2xl mx-auto bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-50 rounded-2xl p-8 md:p-10 shadow-sm border" style={{borderColor: '#e5d3b3'}}>
                  <p className="text-base md:text-xl leading-loose md:leading-loose text-center" style={{color: '#8b4513', fontWeight: '500', letterSpacing: '0.02em'}}>
                    <span style={{color: '#ff8c00'}}>立石農園</span>へのご相談・お問い合わせ。<br className="hidden md:block" />
                    <span style={{color: '#ff8c00'}}>農作物</span>のこと、<span style={{color: '#ff8c00'}}>取引</span>のこと、農園見学のこと。<br className="hidden md:block" />
                    どんな小さなことでも、<span style={{color: '#ff8c00'}}>お気軽</span>にご相談ください。<br className="hidden md:block" />
                    私たちと<span style={{color: '#ff8c00'}}>一緒</span>に、より良い農業の<span style={{color: '#ff8c00'}}>未来</span>を作りましょう。
                  </p>
                </div>
              </div>

              <div className="text-center">
                <button
                  onClick={() => navigate('/contact')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#8b4513',
                    border: '2px solid #8b4513',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 69, 19, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  お問い合わせする
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>

    </div>
  );
}